import React, { Component } from 'react';
import { connect } from 'react-redux';
import GridContainer from "../../../../../components/Grid/GridContainer";
import GridItem from "../../../../../components/Grid/GridItem";
import {
    TextField,
    DialogTitle,
    DialogContent,
    DialogContentText, DialogActions, Dialog,
    Tooltip
} from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Button from "components/CustomButtons/Button.js";
import MenuItem from "@material-ui/core/MenuItem";
import {
    populateOrderPage,
    updateSelectedDeliverySite,
    updateSelectedQuote,
    updateSelectedBranch,
    updateCusNumber,
    updateSpecialInstructions,
    updateReqDelDate,
    UpdateNMBSReference,
    loadingPage,
    populateOrderFromBasket,
    deleteBasket,
    updateProductListByQuote,
    resetWeight,
    productLoading,
    resetProductBasket,
    updateDeliverySiteList
} from '../../../../store/actions';
import { isEmpty } from "lodash"
import authService from '../../../../../components/api-authorization/AuthorizeService'
import SnackbarContent from "components/Snackbar/SnackbarContent.js";
import Warning from "@material-ui/icons/Warning";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import '../../../../../../src/assets/css/customAlert.css';
import history from '../../../../../history';
import { withRouter } from "react-router-dom";
import { compose } from "redux";
import packageJson from '../../../../../../../ClientApp/package.json';
import { ToastContainer, toast }  from "react-toastify";
import JSFile from "../../../../../../package.json";
import Client from "getaddress-api";
import LoadingModal from "../../../../../components/LoadingModal";
import InfoIcon from '@material-ui/icons/Info';
import RefreshIcon from '@material-ui/icons/Refresh';

const successMessage = (msg) => toast.success(msg , {
    position: "bottom-right",
    autoClose: 7000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: 'colored'
});

const errorMess = (msg) => toast.error(msg, {
    position: "bottom-right",
    autoClose: 7000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: 'colored'
});
const invalidPCMessage = () => toast.error('Invalid UK Postcode', {
    position: "bottom-right",
    autoClose: 7000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: 'colored'
});

class PlaceOrderClass extends Component {

    state = {
        username: '',
        userSavedInStore: false,
        todaysDate: '',
        reqDateOK: true,
        openModal: false,
        SubmitLoading: false,
        
        // New delivery site modal fields
        postcode: '',
        addressline1: '',
        addressline2: '',
        addressline3: '',
        addressline4: '',
        town: '',
        city: '',
        county: '',
        newDeliverySite: '',
        selectedAddress: [],
        apiAddressList: [],
        addressList: [],
        
        // Error message helpers
        newDeliverySiteError: false,
        postcodeError: false,
        addressline1Error: false,
        cityError: false,
        townError: false,
    }

    onAutoPopulateAddrChange = (event) => {
        try {

            var selectedAddr = event.target.value;

            if (!isEmpty(selectedAddr)) {

                // Auto Populate fields 
                this.setState({
                    city: selectedAddr.town_or_city, cityError: false,
                    addressline1: selectedAddr.line_1, addressline1error: false,
                    addressline2: selectedAddr.line_2,
                    addressline3: selectedAddr.line_3,
                    addressline4: selectedAddr.line_4,
                    county: selectedAddr.county == "County Londonderry" ? "County Derry/Londonderry" : selectedAddr.county,
                    town: isEmpty(selectedAddr.locality) ? selectedAddr.town_or_city : selectedAddr.locality, // city and town can be the same 
                    country: selectedAddr.country,
                    selectedAddress: selectedAddr
                }, () => {
                });

            }
        } catch (e) {

        }
    };

    isValidPostcode(p) {
        var postcodeRegEx = /[A-Z]{1,2}[0-9]{1,2} ?[0-9][A-Z]{2}/i;
        return postcodeRegEx.test(p);
    }

    PopulateAPIAddresses() {
        try {
            const formatAdd = this.state.addressList.addresses?.map((row, i) => {
                var filtered = row.formatted_address.filter(Boolean);
                var splitRows = filtered.join(', ');
                return (
                    <MenuItem key={i} value={row} style={{ padding: '8px', paddingRight: '30px', paddingLeft: '15px', display: "flex" }}>
                        {splitRows}
                    </MenuItem>
                )
            });
            this.setState({ apiAddressList: formatAdd }, () => { });
        }
        catch (e) {
        }
    };


    async findAddresses() {
        try {

            const { postcode } = this.state;

            if (this.isValidPostcode(postcode)) {
                var postcodeRegEx = /(^[A-Z]{1,2}[0-9]{1,2})([0-9][A-Z]{2}$)/i;

                var formatPC = postcode.replace(postcodeRegEx, "$1 $2"); // fix postcode format to suit the API

                const key = JSFile.pcKey;

                const api = new Client(key);  // api key
                const findResult = await api.find(formatPC);


                if (findResult.isSuccess) {
                    const success = findResult.toSuccess();

                    this.setState({
                        addressList: success.addresses
                    }, () => {
                    });

                    this.PopulateAPIAddresses();
                }
                else {
                    const failed = findResult.toFailed();
                }

            }
            else {

                // not a valid UK post
                // Display message
                this.setState({ postcodeError: true }, () => { });
                invalidPCMessage();
            }
        } catch (e) {
            console.log(e);
        }

    }

    handleAddress1Line = (e) => {

        this.setState({
            addressline1: e.target.value, addressline1Error: false,
        }, () => {
        });
    }

    handleAddress2Line = (e) => {

        this.setState({
            addressline2: e.target.value
        }, () => {
        });
    }

    handleAddress3Line = (e) => {

        this.setState({
            addressline3: e.target.value
        }, () => {
        });
    }

    handleAddress4Line = (e) => {

        this.setState({
            addressline4: e.target.value
        }, () => {
        });
    }



    handleTownChange = (e) => {
        this.setState({ town: e.target.value, townError: false }, () => {
        });
    }

    handleCityChange = (e) => {
        this.setState({ city: e.target.value, cityError: false }, () => {
        });
    }

    handleCountyChange = (e) => {
        this.setState({ county: e.target.value }, () => {
        });
    }

    handlePostcodeChange = (e) => {

        this.setState({
            postcode: e.target.value, 
            postcodeError: false,
            selectedAddress: [],
            apiAddressList: [],
            addressList: [],
        }, () => {
        });


    }
    

    handleOpenClick = () => {
        this.setState({ openModal: true }, () => {
        });

    }

    handleCloseClick = () => {
        this.setState({ openModal: false, newDeliverySite: '' }, () => {
        });

    }

    handleAddNewDeliverySite = (e) => {
        this.setState({ newDeliverySite: e.target.value, newDeliverySiteError: false }, () => {
        });
    }

    handleSubmitNewDeliverySite = async () => {
        
        let error = false;
        
        if ((isEmpty(this.state.newDeliverySite))) {
            this.setState({ newDeliverySiteError: true }, () => { });
            error = true;
        }
        if ((isEmpty(this.state.addressline1))) {
            this.setState({ addressline1Error: true }, () => { });
            error = true;
        }
        if (!this.isValidPostcode(this.state.postcode)){
            this.setState({ postcodeError: true }, () => { });
            error = true;
        }
        
        if (error) return;
         
        await this.SubmitNewDeliverySite();

    }

    SubmitNewDeliverySite = async () => {
        try {
            this.setState({ SubmitLoading: true }, () => { });
            
            const token = await authService.getAccessToken();

            const response = await fetch('api/data/addNewDeliverySite/', {
                method: 'post',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify({
                    DeliverySiteName: this.state.newDeliverySite,
                    AddressLine1: this.state.addressline1,
                    AddressLine2: this.state.addressline2,
                    AddressLine3: this.state.addressline3,
                    AddressLine4: this.state.addressline4,
                    Postcode: this.state.postcode,
                })
            })
                .then(res => res.json())
                .catch();

            if (response) {
                successMessage('New delivery site added.');
                await this.props.updateDeliverySiteList();
                await this.props.updateSelectedDeliverySite(Number(response.deliverySiteId)); // sets the new delivery site as the selected one
                this.handleCloseClick();
            }
            else {
                errorMess('Error has occurred when attempting to add new delivery site. Please try again!');
            }

        }
        catch (e) {

        }
        finally {
            this.setState({ SubmitLoading: false }, () => { });
        }
        
    }

    async CheckVersion() {
        try {
            const ver = packageJson.releaseVersionNo;
            const token = await authService.getAccessToken();

            const response = await fetch('api/data/getlatestversion/', {
                method: 'post',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                }
            })
            const ret = await response.json();

            if (ver === ret.message) {
                this.GetTodaysDate();

                //NOTE: DO A CHECK IN HERE TO SEE IF AN ERROR HAS OCCURRED, IF IT HAS 
                //      STOP THE LOADING SCREEN AND DISPLAY AN ERROR MESSAGE

                if (this.props.errorOccurred) {

                    //history.push('/error-page');


                    this.props.history.push("/error-page");
                }
                else {
                    if (this.props.orderStarted === false) {

                        if (isEmpty(this.props.user)) {
                            //dont have user

                            this.populatePage();
                        }
                        else {
                            //found user
                            this.setState({ username: this.props.user.email, userSavedInStore: true }, () => {

                                this.PopulateOrderPage();
                            });
                        }

                    }
                }

            }
            else {
                window.location.reload();
            }

        }
        catch (e) {

        }
    }


    componentDidMount() {
        this.CheckVersion();
    }

    async CheckForBasket() {


        const token = await authService.getAccessToken();

        const response = await fetch('api/data/checkforbasket/', {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        })
            .then(res => res.json())
            .catch();


        let data = await response;


        if (data.success) { //this means that there is a basket saved in db

            //show an alert to say if you want to continue with current order or start new
            
            if (data.quoteId !== null && data.quoteId !== 0){
                await this.props.updateProductListByQuote(data.quoteId);
            }

            await this.props.populateOrderFromBasket(data);

            confirmAlert({
                closeOnClickOutside: false,
                customUI: ({ onClose }) => {
                    return (
                        <div className='custom-ui'>
                            <h3><b>Order in progress</b></h3>
                            <h5>You previously started an order but never completed it. Do you wish to continue this order?</h5>
                            <button onClick={onClose}>Yes</button>
                            <button
                                onClick={() => {
                                    this.DeleteBasket();
                                    this.props.updateProductListByQuote(0);
                                    onClose();
                                }}
                            >
                                No
                            </button>
                        </div>
                    );
                }
            });



        }

    }

    async DeleteBasket() {

        //delete the basket and call reset order

        //within this method, reset various states
        await this.props.deleteBasket();


    }

    GetTodaysDate() {
        var today = new Date();
        var dd = String(today.getDate()).padStart(2, '0');
        var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
        var yyyy = today.getFullYear();


        today = yyyy + '-' + mm + '-' + dd;

        this.setState({ todaysDate: today });

        if (this.props.reqDelDate !== '') {

            if (this.props.reqDelDate < today) {
                this.setState({ reqDateOK: false });

            } else {
                this.setState({ reqDateOK: true });

            }
        }
    }

    async populatePage() {
        //await this.props.loadingPage(true);
        const [isAuthenticated, user] = await Promise.all([authService.isAuthenticated(), authService.getUser()])

        this.setState({ username: user && user.name, userSavedInStore: false }, () => {

        });

        await this.PopulateOrderPage();

        //await this.props.loadingPage(false);


    }

    async PopulateOrderPage() {
        await this.props.loadingPage(true);
        await this.props.populateOrderPage(this.state.username, this.state.userSavedInStore);

        if (isEmpty(this.props.nmbsReference)) {

            if ((isEmpty(this.props.user.nmbsReference))) {
                await this.props.UpdateNMBSReference('')
            }
            else {
                // use customer ref if default branch nmbs is null
                await this.props.UpdateNMBSReference(this.props.user.nmbsReference)
            }
        }

        //check here for anything saved in basket
        await this.CheckForBasket();
        await this.props.loadingPage(false);
    }

    onOrderNoChange = (e) => {

        this.props.updateCusNumber(e.target.value);
    }

    onSpecialInstructionsChange = (e) => {

        this.props.updateSpecialInstructions(e.target.value);
    }

    onReqDateChange = (e) => {



        this.props.updateReqDelDate(e.target.value);

        if (e.target.value < this.state.todaysDate) {
            this.setState({ reqDateOK: false });

        } else {
            this.setState({ reqDateOK: true });

        }

    }

    render() {

        const onBranchChange = async (event) => {
            this.props.updateSelectedBranch(event.target.value);

            let selectedBranch = this.props.branchList.find(x => x.id === parseInt(event.target.value)); // finds selected branch and checks if it has a ref

            // Updates redux nmbs ref to either branch or user depdning on if they are empty (always prioritising the branch nmbs over the userS)
            if (isEmpty(selectedBranch.nmbsReference)) {

                if ((isEmpty(this.props.user.nmbsReference))) {
                    await this.props.UpdateNMBSReference('')
                }
                else {
                    // use customer ref if branch list if empty
                    await this.props.UpdateNMBSReference(this.props.user.nmbsReference)
                }
            }
            else {
                await this.props.UpdateNMBSReference(selectedBranch.nmbsReference)
            }
        };



        const onDelSiteChange = (event) => {
            this.props.updateSelectedDeliverySite(event.target.value);
        };

        const onQuoteChange = async (selectedQuoteId) => {
            var hasItemInBasket = false;

            for (var i in this.props.productList) {
                if (hasItemInBasket) break;
                if (this.props.productList[i].packs !== 0){
                    hasItemInBasket = true;
                }
            }
            if (hasItemInBasket) {
                //confirm alert
                confirmAlert({
                    closeOnClickOutside: false,
                    customUI: ({ onClose }) => {
                        return (
                            <div className='custom-ui'>
                                <h3><b>Changing quote</b></h3>
                                <h5>Picking a different quote will remove any selected products, are you sure you wish to do so?</h5>
                                <button onClick={ async () => {
                                    onClose();
                                    await this.props.productLoading(true);
                                    this.props.updateSelectedQuote(selectedQuoteId);
                                    await this.props.updateProductListByQuote(selectedQuoteId);
                                    await this.props.resetProductBasket();
                                    await this.props.productLoading(false);
                                }}
                                >
                                    Yes
                                </button>
                                <button
                                    onClick={onClose}
                                >
                                    No
                                </button>
                            </div>
                        );
                    }
                });
            }
            else {
                await this.props.productLoading(true);
                this.props.updateSelectedQuote(selectedQuoteId);
                await this.props.updateProductListByQuote(selectedQuoteId);
                await this.props.resetProductBasket();
                await this.props.productLoading(false);
            }

        };

        let displayOrderOptions;
        let nmbsCusMessage;
        let noDeliverySiteMessage;
        let noProductsMessage;


        if (!isEmpty(this.props.user.nmbsReference)) {
            nmbsCusMessage = (
                <SnackbarContent
                    message={
                        <span>
                            You are a NMBS Customer, please be careful which Branch you choose.
                        </span>
                    }
                    close
                    color="warning"
                    icon={Warning}

                />
            )
        }
        else {
            nmbsCusMessage = "";
        }

        if (isEmpty(this.props.deliverySiteList)) {
            noDeliverySiteMessage = (
                <SnackbarContent
                    message={
                        <span>
                            No Delivery Sites Available To Complete The Order, Please Contact FP McCann Sales.
                        </span>
                    }
                    close
                    color="danger"
                    icon={Warning}

                />
            )
        }
        else {
            noDeliverySiteMessage = "";
        }

        if (isEmpty(this.props.productList) && this.props.quoteId) {
            noProductsMessage = (
                <SnackbarContent
                    message={
                        <span>
                            No Products Could Be Retrieved, Please Contact FP McCann Sales.
                        </span>
                    }
                    close
                    color="danger"
                    icon={Warning}

                />
            )
        }
        else {
            noProductsMessage = "";
        }




        if (isEmpty(this.props.branchList)) {

            /* customer DOES NOT have branches*/

            displayOrderOptions = (<GridContainer>

                <GridItem xs={12} sm={12} md={12}>
                    {noDeliverySiteMessage}
                </GridItem>

                <GridItem xs={12} sm={12} md={12}>
                    {noProductsMessage}
                </GridItem>



                <GridItem xs={12} sm={6} md={6}>
                    <TextField
                        id="orderNo"
                        label="Customer Order Number"
                        placeholder="Customer Order Number (if applicable)...."
                        fullWidth
                        margin="normal"
                        variant="outlined"
                        InputLabelProps={{
                            shrink: true
                        }}
                        onChange={this.onOrderNoChange}
                        value={this.props.cusOrderNumber}
                        autoComplete="on"
                    />
                </GridItem>

                <GridItem xs={12} sm={6} md={6}>
                    <div style={{ display: 'flex', gap: '8px', alignItems: 'flex-start' }}>
                        <div style={{ flex: '5' }}>
                        <TextField
	                        fullWidth
	                        id="ddlDelSite"
	                        select
	                        label={
	                        	<span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
	                        		Delivery Site
	                        		<Tooltip
	                        			title="Please contact our sales team if your delivery site is not in the list"
	                        			placement="right"
	                        			arrow
	                        		>
	                        			<InfoIcon fontSize="small" color="action" style={{ cursor: 'help' }} />
	                        		</Tooltip>
	                        	</span>
	                        }
	                        required
	                        InputLabelProps={{
	                        	shrink: true,
	                        	style: { pointerEvents: 'auto' } // enable hover on icon
	                        }}
	                        value={this.props.selectedDelSiteId}
	                        onChange={onDelSiteChange}
	                        SelectProps={{ native: true }}
	                        margin="normal"
	                        variant="outlined"
                        >                       
                        	{this.props.deliverySiteList.map(x => (
                        		<option key={x.id} value={x.id}>{x.displayText}</option>
                        	))}
                        </TextField>
                        </div>
                        <div style={{ flex: '1', marginTop: '11.5px' }}>
                            <Button
                                fullWidth
                                style={{
                                    borderRadius: '4px',
                                    height: '54px',
                                    fontSize: '12px',
                                }}
                                color="instagram"
                                variant="contained"
                                onClick={
                                    async () => {
                                        await this.props.updateDeliverySiteList();
                                    }
                                }
                            >
                                <RefreshIcon fontSize="small" color="white" />
                            </Button>
                        </div>
                    </div>
                </GridItem>

                <GridItem xs={12} sm={6} md={6}>
                    <Autocomplete
						id="ddlQuote"
						options={this.props.quoteList}
						getOptionLabel={(option) => option.displayText || ""}
						value={
							this.props.quoteList.find(q => q.id === this.props.selectedQuoteId) || null
						}
						isOptionEqualToValue={(option, value) => option.id === value.id}
						onChange={(event, newValue) => {
							onQuoteChange(newValue ? newValue.id : 0); // set to 0 (or null) to clear
						}}
						renderInput={(params) =>
							<TextField
								{...params}
                                label={
                                    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
                                        Quote
                                        <Tooltip
                                            title="Please search / select quotation to build an order from a current live quote. Alternatively you may skip this step and select quantities from your customer price list below"
                                            placement="right"
                                            arrow
                                        >
                                            <InfoIcon fontSize="small" color="action" style={{ cursor: 'help' }} />
                                        </Tooltip>
                                    </span>
                                }
								placeholder="Type in to search for a quote"
								margin="normal"
								variant="outlined"
                                InputLabelProps={{
                                    shrink: true,
                                    style: { pointerEvents: 'auto' } // enable hover on icon
                                }}
							/>
						}
					/>
                </GridItem>



                <GridItem xs={12} sm={6} md={6}>
                    <TextField
                        type="date"
                        id="dateDel"
                        label="Requested Delivery Date"
                        required
                        fullWidth
                        margin="normal"
                        variant="outlined"
                        InputLabelProps={{
                            shrink: true
                        }}
                        value={this.props.reqDelDate}
                        onChange={this.onReqDateChange}
                        autoComplete="off"
                        error={!this.state.reqDateOK}
                        helperText={!this.state.reqDateOK ? 'Please select a future date' : ''}

                    />
                </GridItem>

                <GridItem xs={12} sm={6} md={6}>
                    <TextField
                        type="text"
                        rows={3}
                        id="txtInstructions"
                        label="Special Instructions"
                        placeholder="Special Instructions...."
                        fullWidth
                        margin="normal"
                        variant="outlined"
                        InputLabelProps={{
                            shrink: true
                        }}
                        multiline={true}
                        onChange={this.onSpecialInstructionsChange}
                        value={this.props.specialInstructions}
                        autoComplete="off"
                    />
                </GridItem>

                <GridItem xs={12} sm={6} md={6}>
                </GridItem>
            </GridContainer>);

        }
        else {

            /* customer has branches*/


            displayOrderOptions = (<GridContainer>

                <GridItem xs={12} sm={12} md={12}>
                    {noDeliverySiteMessage}
                </GridItem>

                <GridItem xs={12} sm={12} md={12}>
                    {noProductsMessage}
                </GridItem>

                <GridItem xs={12} sm={12} md={12}>
                    {nmbsCusMessage}
                </GridItem>

                <GridItem xs={12} sm={6} md={6}>
                    <TextField
                        fullWidth
                        id="ddlBranch"
                        select
                        label="Branch"
                        required
                        InputLabelProps={{
                            shrink: true
                        }}
                        value={this.props.selectedBranchId}
                        onChange={onBranchChange}
                        SelectProps={{
                            native: true
                        }}
                        margin="normal"
                        variant="outlined"
                    >
                        {this.props.branchList.map(z => (
                            <option key={z.id} value={z.id}>
                                {z.displayText}
                            </option>
                        ))}
                    </TextField>
                </GridItem>

                <GridItem xs={12} sm={6} md={6}>
                    <div style={{ display: 'flex', gap: '8px', alignItems: 'flex-start' }}>
                        <div style={{ flex: '5' }}>
                        <TextField
	                        fullWidth
	                        id="ddlDelSite"
	                        select
	                        label={
	                        	<span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
	                        		Delivery Site
	                        		<Tooltip
	                        			title="Please contact our sales team if your delivery site is not in the list"
	                        			placement="right"
	                        			arrow
	                        		>
	                        			<InfoIcon fontSize="small" color="action" style={{ cursor: 'help' }} />
	                        		</Tooltip>
	                        	</span>
	                        }
	                        required
	                        InputLabelProps={{
	                        	shrink: true,
	                        	style: { pointerEvents: 'auto' } // enable hover on icon
	                        }}
	                        value={this.props.selectedDelSiteId}
	                        onChange={onDelSiteChange}
	                        SelectProps={{ native: true }}
	                        margin="normal"
	                        variant="outlined"
                        >                       
                        	{this.props.deliverySiteList.map(x => (
                        		<option key={x.id} value={x.id}>{x.displayText}</option>
                        	))}
                        </TextField>
                        </div>
                        <div style={{ flex: '1', marginTop: '11.5px' }}>
                        <Tooltip title="Refresh delivery site list">
                            <Button
                                fullWidth
                                style={{
                                    borderRadius: '4px',
                                    height: '54px',
                                    fontSize: '12px',
                                }}
                                color="instagram"
                                variant="contained"
                                onClick={
                                    async () => {
                                        await this.props.updateDeliverySiteList();
                                    }
                                }
                            >
                                
                                    <RefreshIcon fontSize="small" color="white" />
                            </Button>
                        </Tooltip>
                        </div>
                    </div>
                </GridItem>

                <Dialog fullWidth={true} maxWidth={"lg"} open={this.state.openModal} onClose={this.handleCloseClick}>
                    <DialogTitle>Add a new delivery site</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            Enter your new delivery site and click on the submit button to add a new site.
                        </DialogContentText>
                        <GridContainer>
                            
                            <GridItem xs={12} sm={12} md={12}>
                                <TextField
                                    id="DelSiteName"
                                    label="Delivery Site Name"
                                    required
                                    fullWidth
                                    margin="normal"
                                    variant="outlined"
                                    InputLabelProps={{
                                        shrink: true

                                    }}
                                    type="text"
                                    onChange={this.handleAddNewDeliverySite}
                                    error={this.state.newDeliverySiteError}
                                    helperText={this.state.newDeliverySite === "" ? 'Please enter delivery site name.' : ' '}
                                    value={this.state.newDeliverySite === null ? "" : this.state.newDeliverySite ? this.state.newDeliverySite : ''}
                                />


                            </GridItem>
                            
                        {!isEmpty(this.state.apiAddressList) ?
                            <GridItem xs={12} sm={12} md={12}>
                                <TextField
                                    fullWidth
                                    id="apiAdd"
                                    label="Address List"
                                    helperText="Please select your address"
                                    margin="normal"
                                    variant="outlined"
                                    select
                                    focused
                                    onChange={this.onAutoPopulateAddrChange}
                                >
                                    {this.state.apiAddressList}
                                </TextField>
                            
                            
                            </GridItem>
                            : null}
                            
                            <GridItem xs={6} sm={3} md={3}>
                                <TextField
                                    style={{ display: "flex" }}
                                    id="postcode"
                                    label="Postcode"
                                    fullWidth
                                    margin="normal"
                                    variant="outlined"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    type="text"
                                    value={this.state.postcode === null ? "" : this.state.postcode ? this.state.postcode : ''}
                                    onChange={this.handlePostcodeChange}
                                    error={this.state.postcodeError}
                                    helperText={this.state.postcodeError ? "Please enter a valid UK postcode!" : null}
                                    focused

                                />

                            </GridItem>

                            <GridItem xs={6} sm={3} md={3} style={{ padding: '16px' }}>
                                <Button
                                    style={{
                                        borderRadius: 2,
                                        padding: "14px 16px",
                                        fontSize: "12px"
                                    }}

                                    color="instagram"
                                    size="lg"
                                    target="_blank"
                                    onClick={() => this.findAddresses()}
                                >
                                    <i className="fas fa-location-arrow"></i>
                                    &nbsp;  Find Address
                                </Button>
                            </GridItem>

                            <GridItem xs={12} sm={6} md={6}>
                            </GridItem>

                            <GridItem xs={12} sm={6} md={6}>

                                <TextField
                                    id="address1"
                                    label="Address Line 1"
                                    required
                                    fullWidth
                                    margin="normal"
                                    variant="outlined"
                                    InputLabelProps={{
                                        shrink: true

                                    }}
                                    type="text"
                                    error={this.state.addressline1Error}
                                    helperText={this.state.addressline1Error ? "Please enter address line 1!" : null}
                                    onChange={this.handleAddress1Line}
                                    value={this.state.addressline1 === null ? "" : this.state.addressline1 ? this.state.addressline1 : ''}
                                />
                            </GridItem>




                            <GridItem xs={12} sm={6} md={6}>
                                <TextField
                                    id="address2"
                                    label="Address Line 2"
                                    fullWidth
                                    margin="normal"
                                    variant="outlined"
                                    InputLabelProps={{
                                        shrink: true

                                    }}
                                    type="text"
                                    onChange={this.handleAddress2Line}
                                    value={this.state.addressline2 === null ? "" : this.state.addressline2 ? this.state.addressline2 : ''}
                                />
                            </GridItem>



                            <GridItem xs={12} sm={6} md={6}>
                                <TextField
                                    id="address3"
                                    label="Address Line 3"
                                    fullWidth
                                    margin="normal"
                                    variant="outlined"
                                    InputLabelProps={{
                                        shrink: true

                                    }}
                                    type="text"
                                    onChange={this.handleAddress3Line}
                                    value={this.state.addressline3 === null ? "" : this.state.addressline3 ? this.state.addressline3 : ''}
                                />


                            </GridItem>


                            <GridItem xs={12} sm={6} md={6}>
                                <TextField
                                    id="address4"
                                    label="Address Line 4"
                                    fullWidth
                                    margin="normal"
                                    variant="outlined"
                                    InputLabelProps={{
                                        shrink: true

                                    }}
                                    type="text"
                                    onChange={this.handleAddress4Line}
                                    value={this.state.addressline4 === null ? "" : this.state.addressline4 ? this.state.addressline4 : ''}
                                />


                            </GridItem>

                            <GridItem xs={12} sm={6} md={6}>
                                <TextField
                                    id="town"
                                    label="Town"
                                    fullWidth
                                    margin="normal"
                                    variant="outlined"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    error={this.state.townError}
                                    helperText={this.state.townError ? "Please enter a town!" : null}
                                    type="text"
                                    onChange={this.handleTownChange}
                                    value={this.state.town === null ? "" : this.state.town ? this.state.town : ''}
                                />


                            </GridItem>

                            <GridItem xs={12} sm={6} md={6}>
                                <TextField
                                    id="city"
                                    label="City"
                                    fullWidth
                                    margin="normal"
                                    variant="outlined"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    error={this.state.cityError}
                                    helperText={this.state.cityError ? "Please enter a city" : null}
                                    type="text"
                                    onChange={this.handleCityChange}
                                    value={this.state.city === null ? "" : this.state.city ? this.state.city : ''}
                                />


                            </GridItem>

                            <GridItem xs={12} sm={6} md={6}>
                                <TextField
                                    id="county"
                                    label="County"
                                    fullWidth
                                    margin="normal"
                                    variant="outlined"
                                    InputLabelProps={{
                                        shrink: true

                                    }}
                                    type="text"
                                    onChange={this.handleCountyChange}
                                    value={this.state.county === null ? "" : this.state.county ? this.state.county : ''}
                                />


                            </GridItem>
                        </GridContainer>
                        
                    </DialogContent>
                    <DialogActions>

                        <Button
                            style={{
                                borderRadius: 2,
                                padding: "9px 23px",
                                fontSize: "15px"
                            }}
                            color="danger"
                            size="lg"
                            target="_blank"
                            onClick={this.handleCloseClick}
                        >

                            Cancel
                        </Button>
                        <Button
                            style={{

                                borderRadius: 2,
                                padding: "9px 23px",
                                fontSize: "15px"
                            }}

                            color="success"
                            size="lg"
                            target="_blank"
                            onClick={this.handleSubmitNewDeliverySite}
                        >

                            Submit
                        </Button>
                    </DialogActions>
                </Dialog>

                <GridItem xs={12} sm={6} md={6}>
                <Autocomplete
						id="ddlQuote"
						options={this.props.quoteList}
						getOptionLabel={(option) => option.displayText || ""}
						value={
							this.props.quoteList.find(q => q.id === this.props.selectedQuoteId) || null
						}
						isOptionEqualToValue={(option, value) => option.id === value.id}
						onChange={(event, newValue) => {
							onQuoteChange(newValue ? newValue.id : 0); // set to 0 (or null) to clear
						}}
						renderInput={(params) =>
							<TextField
								{...params}
                                label={
                                    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
                                        Quote
                                        <Tooltip
                                            title="Please search / select quotation to build an order from a current live quote. Alternatively you may skip this step and select quantities from your customer price list below"
                                            placement="right"
                                            arrow
                                        >
                                            <InfoIcon fontSize="small" color="action" style={{ cursor: 'help' }} />
                                        </Tooltip>
                                    </span>
                                }
								placeholder="Type in to search for a quote"
								margin="normal"
								variant="outlined"
                                InputLabelProps={{
                                    shrink: true,
                                    style: { pointerEvents: 'auto' } // enable hover on icon
                                }}
							/>
						}
					/>
                </GridItem>

                <GridItem xs={12} sm={6} md={6}>
                    <TextField
                        id="orderNo"
                        label="Customer Order Number"
                        placeholder="Customer Order Number (if applicable)...."
                        fullWidth
                        margin="normal"
                        variant="outlined"
                        InputLabelProps={{
                            shrink: true
                        }}
                        onChange={this.onOrderNoChange}
                        value={this.props.cusOrderNumber}
                        autoComplete="off"
                    />
                </GridItem>

                <GridItem xs={12} sm={6} md={6}>
                    <TextField
                        type="date"
                        id="dateDel"
                        label="Requested Delivery Date"
                        required
                        fullWidth
                        margin="normal"
                        variant="outlined"
                        InputLabelProps={{
                            shrink: true
                        }}
                        value={this.props.reqDelDate}
                        onChange={this.onReqDateChange}
                        autoComplete="off"
                        error={!this.state.reqDateOK}
                        helperText={!this.state.reqDateOK ? 'Please select a future date' : ''}

                    />
                </GridItem>

                <GridItem xs={12} sm={6} md={6}>
                    <TextField
                        type="text"
                        rows={3}
                        id="txtInstructions"
                        label="Special Instructions"
                        placeholder="Special Instructions...."
                        fullWidth
                        margin="normal"
                        variant="outlined"
                        InputLabelProps={{
                            shrink: true
                        }}
                        multiline={true}
                        onChange={this.onSpecialInstructionsChange}
                        value={this.props.specialInstructions}
                        autoComplete="off"
                    />
                </GridItem>

                <GridItem xs={12} sm={6} md={6}>
                </GridItem>
            </GridContainer>);
        }


        return (<div>
            {displayOrderOptions}
            <LoadingModal active={this.state.SubmitLoading} text="Please wait..." />
            <div>
                <ToastContainer
                    position="bottom-right"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                />
            </div>

        </div>);
    }
}

const mapStateToProps = state => {
    return {
        user: state.userReducer.user,
        branchList: state.orderReducer.branchList,

        deliverySiteList: state.orderReducer.deliverySiteList,
        selectedBranchId: parseInt(state.orderReducer.selectedBranchId),
        selectedDelSiteId: parseInt(state.orderReducer.selectedDeliverySiteId),
        quoteList: state.orderReducer.quoteList,
        selectedQuoteId: parseInt(state.orderReducer.selectedQuoteId),
        orderStarted: state.orderReducer.orderProcessStarted,
        cusOrderNumber: state.orderReducer.cusOrderNumber,
        specialInstructions: state.orderReducer.specialInstructions,
        reqDelDate: state.orderReducer.reqDelDate,
        productList: state.orderReducer.productList,
        nmbsReference: state.orderReducer.nmbsReference,
        loadingdata: state.userReducer.loadingPage,
        errorOccurred: state.orderReducer.errorOccurred,
    };
};

//export default connect(mapStateToProps, {
//    populateOrderPage, updateSelectedDeliverySite,
//    updateSelectedBranch, updateCusNumber, updateSpecialInstructions, updateReqDelDate, UpdateNMBSReference,
//    loadingPage, populateOrderFromBasket, deleteBasket
//})(PlaceOrderClass);

export default compose(withRouter, connect(mapStateToProps, {
    populateOrderPage, updateSelectedDeliverySite, updateSelectedQuote,updateProductListByQuote,
    updateSelectedBranch, updateCusNumber, updateSpecialInstructions, updateReqDelDate, UpdateNMBSReference,
    loadingPage, populateOrderFromBasket, deleteBasket, resetWeight, productLoading, resetProductBasket, updateDeliverySiteList
}))(PlaceOrderClass);